import { Navigate } from "react-router-dom";
import { useSingleton } from "../../hooks/use-singleton";
import { COOKIE_ACCESS_ROLE } from "../../utils/storage-constants";
import { ROUTE_LOGIN } from "../../route/index";

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { role } = useSingleton();
  const finalRole = role || localStorage.getItem(COOKIE_ACCESS_ROLE);

  if (!finalRole) {
    return <Navigate to={ROUTE_LOGIN} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(finalRole)) {
    return <Navigate to={ROUTE_LOGIN} replace />;
  }

  return children;

};


